import { render, staticRenderFns } from "./SdsItems.vue?vue&type=template&id=315f7772&scoped=true&"
import script from "./SdsItems.vue?vue&type=script&lang=js&"
export * from "./SdsItems.vue?vue&type=script&lang=js&"
import style0 from "./SdsItems.vue?vue&type=style&index=0&id=315f7772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f7772",
  null
  
)

export default component.exports